// A React modal component for selecting a date range. 
// It displays start and end date pickers and a submit button, 
// and is used to filter map data by date.


const CalendarModal = ({
  open,
  onClose,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  submitDateRange,
  t,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-bold mb-4">{t("map_page.date_range.title")}</h2>

        <label className="block text-gray-700 mb-2">{t("map_page.date_range.start_date")}</label>
        <input
          type="date"
          className="border border-gray-300 rounded p-2 w-full mb-4"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <label className="block text-gray-700 mb-2">{t("map_page.date_range.end_date")}</label>
        <input
          type="date"
          className="border border-gray-300 rounded p-2 w-full mb-4"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <div className="flex justify-end gap-2">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            onClick={submitDateRange}
          >
            {t("map_page.date_range.submit")}
          </button>
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            onClick={onClose}
          >
            {t("map_page.date_range.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CalendarModal;
